export const errorToastMiddleware = (store) => (next) => (action) => {
	// Sprawdzamy czy to akcja rejected z createAsyncThunk
	if (action.type?.endsWith("/rejected")) {
		const state = store.getState();
		const error = action.payload;

		// Sprawdzamy czy błąd nie powinien być ignorowany
		if (shouldIgnoreError(error, action)) {
			return next(action);
		}

		// Dynamiczny import toasta
		import("../../helpers/toastWrapper").then(({ toast }) => {
			const errorMessage = getErrorMessage(error, state);
			if (errorMessage) {
				toast.error(errorMessage);
			}
		});
	}

	return next(action);
};

/**
 * Sprawdza czy błąd powinien być ignorowany (nie wyświetlać toasta)
 */
function shouldIgnoreError(error, action) {
	// Ignoruj błędy anulowania requestów
	if (error?.code === "ERR_CANCELED" || error?.message === "canceled") {
		return true;
	}

	// Ignoruj błędy sieciowe
	if (error?.code === "ERR_NETWORK") {
		return true;
	}

	// Ignoruj błędy timeout (będą obsłużone przez clientMiddleware)
	if (error?.code === "ECONNABORTED" && error?.message?.includes("timeout")) {
		return true;
	}

	// Możesz dodać flagę noToast w meta akcji
	if (action.meta?.noToast) {
		return true;
	}

	return false;
}

/**
 * Wyciąga wiadomość błędu z różnych formatów
 */
function getErrorMessage(error, state) {
	const language = state?.globalCommon?.language || "pl";

	// Błąd z createApiCall (Axios error)
	if (error?.data?.error) {
		return error.data.error;
	}

	// Sprawdź status codes i zwróć odpowiednie komunikaty
	if (error?.status === 401 || error?.status === 409) {
		// Te błędy są obsłużone przez clientMiddleware (logout)
		return null;
	}

	if (error?.status === 550) {
		const messages = {
			pl: "Trwa aktualizacja oprogramowania...",
			cs: "Probíhá aktualizace softwaru...",
			de: "Software ist gegenwärtig aktualisiert...",
			en: "Updating software...",
			ru: "Обновление программного обеспечения...",
			uk: "Оновлення програмного забеспечення ...",
		};
		return messages[language];
	}

	if (error?.status === 504) {
		const messages = {
			pl: "Wystąpił problem komunikacji z serwerem - przekroczono limit czasu połączenia.",
			cs: "Při komunikaci se serverem došlo k problému – vypršel časový limit připojení.",
			de: "Es gab ein Problem bei der Kommunikation mit dem Server – Zeitüberschreitung bei der Verbindung.",
			en: "There was a problem communicating with the server - connection timed out.",
			ru: "Возникла проблема со związью с сервером - время ожидания соединения истекло.",
			uk: "Виникла проблема зв'язку із сервером – минув час очікування з'єднання.",
		};
		return messages[language];
	}

	// Błąd jako string
	if (typeof error === "string") {
		return error;
	}

	// Fallback dla nieznanych błędów
	const messages = {
		pl: "Wystąpił nieznany błąd.",
		cs: "Nastala neznámá chyba.",
		de: "Ein unbekannter Fehler ist aufgetreten.",
		en: "An unknown error occurred.",
		ru: "Произошла неизвестная ошибка.",
		uk: "Сталася невідома помилка.",
	};

	return messages[language];
}
